import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotDisc = ({
    spotColor = "#C6F4EC",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#Spot=on,_Size=40_svg__a)">
            <path
                fill={spotColor}
                d="M4.857 17.78c1.738-5.087 7.916-9.787 13.373-11.594 5.482-1.818 11.979-.362 16.283 3.888 4.304 4.25 6.402 10.611 5.107 15.97-1.26 5.374-5.757 8.608-9.715 10.583-3.983 1.985-7.428 1.992-11.538.997-4.123-.96-8.301-2.541-10.448-6.26-2.147-3.72-4.824-8.487-3.062-13.584Z"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M19.999 36.666c9.204 0 16.666-7.462 16.666-16.666 0-9.205-7.462-16.667-16.666-16.667-9.205 0-16.667 7.462-16.667 16.667 0 9.204 7.462 16.666 16.667 16.666Z"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M20 25a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
            />
        </g>
        <defs>
            <clipPath id="Spot=on,_Size=40_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotDisc.displayName = "SpotDisc";
